<template>
    <div>
        <navbar :title="text"></navbar>
        <teamtop></teamtop>
    </div>
</template>

<script>
import navbar from '../../components/Navbar'
import teamtop from '../../components/team_top'
export default {
    components:{
        navbar,
        teamtop,
    },
    data(){
        return{
            text:'我的团队'
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/team/team.vue